import { useState } from 'react'
import { SignatureAlerte } from '../Types/Class/SignatureAlerte'

export interface UseAlertsManagementReturn {
    seuilAlerte: number
    setSeuilAlerte: (value: number) => void
    personnesAlerter: SignatureAlerte[]
    deletedAlertes: number[]
    selectedPersonneAlerte: number | null
    setSelectedPersonneAlerte: (value: number | null) => void
    handleAddPersonneAlerte: () => void
    handleRemovePersonneAlerte: (idPeople: number) => void
    resetAlertes: () => void
    loadAlertes: (seuil: number, alertes: SignatureAlerte[]) => void
}

export function useAlertsManagement(
    setHasChanges: (value: boolean) => void
): UseAlertsManagementReturn {
    const [seuilAlerte, setSeuilAlerte] = useState<number>(150)
    const [personnesAlerter, setPersonnesAlerter] = useState<SignatureAlerte[]>([])
    const [deletedAlertes, setDeletedAlertes] = useState<number[]>([])
    const [selectedPersonneAlerte, setSelectedPersonneAlerte] = useState<number | null>(null)

    const handleAddPersonneAlerte = () => {
        if (selectedPersonneAlerte && !personnesAlerter.some(p => p.IDPeopleToAlert === selectedPersonneAlerte)) {
            const newAlerte = new SignatureAlerte({
                IDPeopleToAlert: selectedPersonneAlerte
            })
            setPersonnesAlerter([...personnesAlerter, newAlerte])
            setSelectedPersonneAlerte(null)
            setHasChanges(true)
        }
    }

    const handleRemovePersonneAlerte = (idPeople: number) => {
        // Trouver l'alerte à supprimer
        const alerteToRemove = personnesAlerter.find(p => p.IDPeopleToAlert === idPeople)

        // Si l'alerte a un ID (existe en BDD), l'ajouter à la liste des suppressions
        if (alerteToRemove?.IDSignatureParametreAlerte) {
            setDeletedAlertes([...deletedAlertes, alerteToRemove.IDSignatureParametreAlerte])
        }

        // Retirer l'alerte de la liste
        setPersonnesAlerter(personnesAlerter.filter(p => p.IDPeopleToAlert !== idPeople))
        setHasChanges(true)
    }

    const resetAlertes = () => {
        setSeuilAlerte(150)
        setPersonnesAlerter([])
        setDeletedAlertes([])
        setSelectedPersonneAlerte(null)
    }

    const loadAlertes = (seuil: number, alertes: SignatureAlerte[]) => {
        setSeuilAlerte(seuil)
        setPersonnesAlerter(alertes.map(a => new SignatureAlerte(a)))
        setDeletedAlertes([])
    }

    return {
        seuilAlerte,
        setSeuilAlerte,
        personnesAlerter,
        deletedAlertes,
        selectedPersonneAlerte,
        setSelectedPersonneAlerte,
        handleAddPersonneAlerte,
        handleRemovePersonneAlerte,
        resetAlertes,
        loadAlertes,
    }
}
